import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

const init = () => {
  document.querySelectorAll('.block-testimonials__splide').forEach((el) => {
    if (el.dataset.splideInit) return;
    new Splide(el).mount();
    el.dataset.splideInit = '1';
  });
};

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
